import index from "./paymentList.vue";
export default index;
